document.addEventListener("DOMContentLoaded", function () {
  const currentPath = window.location.pathname;

  if (!currentPath.startsWith("/our-services")) {
    return;
  }

  const links = document.querySelectorAll(".content-services__links--web a");
  links.forEach((link) => {
    const linkPath = new URL(link.href).pathname;
    if (currentPath === linkPath || currentPath.startsWith(linkPath)) {
      link.classList.add("active");
    }
  });

  const mobileContainer = document.querySelector(
    ".content-services__links--mobile"
  );
  if (!mobileContainer) return;

  const mobileLinks = Array.from(mobileContainer.querySelectorAll("a"));
  let activeLink = null;

  mobileLinks.forEach((link) => {
    const linkPath = new URL(link.href).pathname;
    if (currentPath === linkPath || currentPath.startsWith(linkPath)) {
      link.classList.add("active");
      activeLink = link;
    }
  });

  if (activeLink) {
    const contentServices = mobileContainer.querySelector(".content__services");
    if (contentServices) {
      mobileContainer.insertBefore(activeLink, contentServices.nextSibling);
    }
  }

  menuToggle(".content-services__links--mobile", ".btn__toggle");
});
